
<ng-template #modalLG let-modal >
    <div class="modal-header p-0" style="background-color: transparent;">
        <button type="button" class=" close" style="margin-right: 5px" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div style="margin: 64px">

    <div class="text-center mb-2">
        <h5 class="titre mb-1">Ajoutez une intégration</h5>
        <p class="sous-titre m-0">Remplissez les informations nécessaires pour ajouter une intégration.</p>
    </div>

    <div class="modal-body p-0" tabindex="0" ngbAutofocus>

        <div class="row justify-content-left text-center modal-integration-form">

            <div class=" col-12 col-md-6 col-lg-4 mb-2">
                <div class="card-model rounded shadow-sm p-1 h-100 text-center position-relative"
                     (click)="selectedIntegration = 'wordpress'">
                    <div style="font-size: 25px ; padding-bottom: 7px">
                        <i class="bi bi-building"></i>
                    </div>
                    <p class="mb-1 font-weight-bold">Wordpress</p>
                    <p class="mb-1 small">List property as Builder, list your project and get highest reach very fast.</p>

                    <div class="d-flex justify-content-center pt-2">
                        <label class="radio-container">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="integrationType"
                                value="wordpress"
                                [(ngModel)]="selectedIntegration"
                                aria-label="Wordpress"
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class=" col-12 col-md-6 col-lg-4 mb-2">
                <div class="card-model rounded shadow-sm p-1 h-100 text-center position-relative"
                     (click)="selectedIntegration = 'prestashop'">
                    <div style="font-size: 25px ; padding-bottom: 7px">
                        <i class="bi bi-gem" ></i>
                    </div>
                    <p class="mb-1 font-weight-bold">Prestashop</p>
                    <p class="mb-1 small">Submit property as an Individual. Lease, Rent or Sell at the best price.</p>

                    <div class="d-flex justify-content-center pt-2">
                        <label class="radio-container">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="integrationType"
                                value="prestashop"
                                [(ngModel)]="selectedIntegration"
                                aria-label="Prestashop"
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div class=" col-12 col-md-6 col-lg-4 mb-2">
                <div class="card-model rounded shadow-sm p-1 h-100 text-center position-relative"
                     (click)="selectedIntegration = 'webapp'">
                    <i data-feather="briefcase" class="mb-2" [size]="25"></i>
                    <p class="mb-1 font-weight-bold">Application web</p>
                    <p class="mb-1 small">Earn highest commission by listing your clients properties at the best price.</p>

                    <div class="d-flex justify-content-center pt-2">
                        <label class="radio-container">
                            <input
                                class="form-check-input"
                                type="radio"
                                name="integrationType"
                                value="webapp"
                                [(ngModel)]="selectedIntegration"
                                aria-label="Application web"
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <div class="center" style="margin-bottom: 24px">
            <label>Nom <span class="text-danger">*</span> </label>
            <input type="text" class="form-control" placeholder="Entrez le nom de l’intégration">
        </div>
        <div class="center" style="margin-bottom: 24px">
            <label>Description </label>
            <input type="text" class="form-control" placeholder="Entrez une description">
        </div>
        <div class="center" style="margin-bottom: 24px">
            <label>Site Web</label>
            <input type="text" class="form-control" placeholder="Entrez le site web">
        </div>
        <div class="center" style="margin-bottom: 24px">
            <label>Lien Webhook </label>
            <input type="text" class="form-control" placeholder="Entrez le lien webhook">
        </div>

    </div>
    <div class="centerButtons">
        <button type="button" class="btn btn-primary" (click)="modal.close('Accept click')" rippleEffect>Valider</button>
        <button type="button" class="btn btn-secondary" (click)="modal.close('Accept click')" rippleEffect>Annuler</button>
    </div>

    </div>
</ng-template>
